import Vue from 'vue'
import VueI18n from 'vue-i18n'

import de from "./de";
import en from "./en";

Vue.use(VueI18n)

// Currently we just use browser language, add language selection etc later probably

let browserLanguage = '';

if(window.navigator.language) {
    //NON-IE
    browserLanguage = window.navigator.language.substr(0, 2);
} else {
    //IE
    browserLanguage = window.navigator.browserLanguage.substr(0, 2);
}

export default new VueI18n({
    locale: browserLanguage, // set locale
    fallbackLocale: 'en',
    messages: {
        de, en
    }
});
